import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function BudgetlinedetailFormReducer(state = initialState.budgetlinedetailForm, action: any) {
  switch (action.type) {
    case types.SAVE_BUDGETLINEDETAILFORM_SUCCESS:
      return action.budgetlinedetailForm;
    default:
      return state;
  }
}
